import React from 'react'
import './style.scss';

const CloseBtn = ({color,closeHandler}) => {
  return (
      <div className="close-btn-container">
    <button style={{color:`var(${color})`}} onClick={closeHandler}>
    <i className="fa-solid fa-xmark"></i>
    </button>
  </div>
  )
}

export default CloseBtn